/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPINDUSTRY = {
    ExtractiveServices: 'E',
    Construction: 'C',
    StateOwnedEnterprise: 'S',
    PublicSector: 'P',
    Agriculture: 'A',
    Manufacturing: 'M',
    FinancialAndBusinessServices: 'F',
    Entrepreneurship: 'EX',
    WholesaleAndRetailTrade: 'W',
    Engineering: 'EN',
    Education: 'ED',
    Healthcare: 'H',
    InformationTechnology: 'I',
    AutomotiveOrAviation: 'AA',
    Hospitality: 'HO',
    NotApplicable: 'N',
    OtherIndustryOrSector: 'O'
} as const;
export type IAPINDUSTRY = typeof IAPINDUSTRY[keyof typeof IAPINDUSTRY];


export function IAPINDUSTRYFromJSON(json: any): IAPINDUSTRY {
    return IAPINDUSTRYFromJSONTyped(json, false);
}

export function IAPINDUSTRYFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPINDUSTRY {
    return json as IAPINDUSTRY;
}

export function IAPINDUSTRYToJSON(value?: IAPINDUSTRY | null): any {
    return value as any;
}

